module.exports = __webpack_public_path__ + "img/backHover2.b8a25ad8.png";